import { ReplaySubject, Observable } from 'rxjs';
import { Utils } from '../fork-common-controls/utils.service';

export abstract class Cache<T> {
  protected subject: ReplaySubject<T> = new ReplaySubject<T>(1);
  private isEmpty: boolean = true;

  public abstract populate(): void;

  public retrieve(refresh: boolean = true): Observable<T> {
    // If the cache is later set up to have expiration rules, enforce them here.

    if (refresh || this.isEmpty) {
      this.isEmpty = false;
      this.populate();
    }

    return this.subject
      .asObservable()
      .map(data => {

        // Deep clone the object so subscribers can't modify the data for each other.
        return Utils.cloneObjectNoProto(data);
      });
  }

  public clear(): void {
    this.subject = new ReplaySubject<T>(1);
  }
}
